export const DIALOG_TYPES = {
  WARNING: 'warning',
  DELETE: 'delete',
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  NOT_ALLOWED: 'notAllowed'
}

export const DIALOG_DENSITY = {
  DEFAULT: 'default',
  COMPACT: 'compact'
}
